import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import { SettingsTable } from "component/organisms/settings-table";
import { SettingsCalender } from "component/organisms/settings-calender";
import { EventSettingDialog } from "component/organisms/event-setting-dialog";
import { useZohoAuthContext, ZohoAuthProvider } from "context/ZohoAuthContext";
import { useEventConfigArray } from "hook/use-event-config-array";

const tabPanelContainerSX = {
  p: "2em",
  borderRadius: "8px",
  maxWidth: "90rem",
  mx: "auto",
};

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: "12px 16px" }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function Route() {
  const context = useZohoAuthContext();
  // console.log({ context });

  const { handleGrantAuth, handleRevokeAuth, authLoadingZoho, zohoAuthenticated } = context;
  const [tabIndex, setTabIndex] = React.useState(0);
  const [eventSettingDialogOpen, setEventSettingDialogOpen] = React.useState(false);
  const [selectedSetting, setSelectedSetting] = React.useState(null);
  const settingArray = useEventConfigArray({ all: true });
  // console.log({ settingArray });

  const handleCloseEventSettingDialog = () => {
    setEventSettingDialogOpen(false);
    setSelectedSetting(null);
  };

  const handleConfirmEventSetting = () => {
    // if (title.trim() && newEvent) {
    //   setEvents((prev) => [...prev, { ...newEvent, title: title.trim() }]);
    // }
    // setTitle("");
    // setNewEvent(null);
    // setCreateDialogOpen(false);
  };

  const handleChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <>
      <Box
        sx={{
          height: "100vh",
          width: "100vw",
          overflow: "hidden",
        }}
      >
        <Tabs
          value={tabIndex}
          onChange={handleChange}
          aria-label="tabs"
          sx={{ overflowX: "auto", borderBottom: 1, borderColor: "divider" }}
          //---------
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
          //---------
        >
          <Tab label="Authentication" sx={{ textTransform: "capitalize" }} {...a11yProps(0)} />
          <Tab label="Settings" disabled={!zohoAuthenticated || authLoadingZoho} sx={{ textTransform: "capitalize" }} {...a11yProps(1)} />
        </Tabs>
        <CustomTabPanel value={tabIndex} index={0}>
          <Box sx={tabPanelContainerSX}>
            <Typography
              sx={{
                mb: "1em",
                // color: "rgba(32,33,35,.9)",
                fontWeight: 700,
              }}
            >
              Authenticate ZOHO CRM and Writer Services for API Access
            </Typography>
            <Typography
              sx={{
                // color: "rgba(32,33,35,.39)",
                fontSize: "14px",
                mb: "1.5em",
              }}
            >
              To effectively utilize the Zoho CRM REST API for sending emails or performing other actions, you'll need to authenticate your
              application with Zoho. This ensures secure access to your CRM and Writer data and enables the API to perform tasks on your
              behalf.
            </Typography>
            {zohoAuthenticated ? (
              <Button
                onClick={handleRevokeAuth}
                variant="contained"
                sx={{
                  textTransform: "capitalize",
                  width: "180px",
                  "-webkit-justify-content": "left",
                  justifyContent: "left",
                }}
              >
                {authLoadingZoho ? "Loading..." : "Revoke"}
              </Button>
            ) : (
              <Button
                onClick={handleGrantAuth}
                variant="contained"
                sx={{
                  textTransform: "capitalize",
                  width: "180px",
                  "-webkit-justify-content": "left",
                  justifyContent: "left",
                }}
              >
                {authLoadingZoho ? "Loading..." : "Authenticate"}
              </Button>
            )}
          </Box>
        </CustomTabPanel>
        <CustomTabPanel value={tabIndex} index={1}>
          <Box sx={tabPanelContainerSX}>
            <SettingsCalender />
            <Box
              sx={{
                mb: ".5em",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  bgcolor: "rgba(199, 199, 199, 0.5)",
                  p: ".5em",
                  borderRadius: "4px",
                }}
              >
                Activities
              </Typography>

              <Button
                variant="contained"
                size="small"
                sx={{ textTransform: "capitalize" }}
                onClick={() => {
                  setEventSettingDialogOpen(true);
                }}
              >
                Add New Activity
              </Button>
            </Box>
            <SettingsTable
              rows={settingArray || []}
              onSelectRow={(settingId) => {
                const selectedSetting = settingArray.find((item) => item.setting_id === settingId);
                setSelectedSetting(selectedSetting);
                setEventSettingDialogOpen(true);
              }}
            />
          </Box>
        </CustomTabPanel>
      </Box>

      {eventSettingDialogOpen ? (
        <EventSettingDialog
          dialogOpen={eventSettingDialogOpen}
          handleCloseDialog={handleCloseEventSettingDialog}
          handleConfirmEvent={handleConfirmEventSetting}
          savedSetting={selectedSetting}
        />
      ) : null}
    </>
  );
}

export function SettingsRoute() {
  return (
    <ZohoAuthProvider>
      <Route />
    </ZohoAuthProvider>
  );
}
